<div class="dialog-padding">
  <h1 mat-dialog-title class="dialog-title">Edit Organization Profile</h1>
  <form [formGroup]="editOrganizationRiderForm" (submit)="handleSubmission()">
    <div class="rider-info">
      <div class="organization-and-customerID">
        <mat-form-field appearance="outline" class="organization-select-bar">
          <mat-label>Organization</mat-label>
          <mat-select
            id="editOrganizationRider-select-organization"
            name="transitProgramId"
            disabled
            [value]="data.organizationRiderDetail.organizationId"
          >
            <mat-option id="editOrganizationRider-option-organization" *ngFor="let organization of data.organizations" [value]="organization?.id">
              {{ organization.name }} ({{ organization.code }})
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Customer ID</mat-label>
          <input id="editOrganizationRider-input-customerId" matInput type="text" formControlName="partnerIdentifier" />
          <mat-error *ngIf="this.editOrganizationRiderForm.get('partnerIdentifier')?.errors"> No special characters </mat-error>
        </mat-form-field>
      </div>

      <div class="ambulatory">
        <uz-organization-rider-service-levels
          [organizationServiceLevels]="data.organizationServiceLevels"
          [organizationRiderServiceLevels]="data.organizationRiderDetail.organizationRiderServiceLevels"
          (organizationServiceLevelChange)="handleOrganizationServiceLevelChange($event)"
        >
        </uz-organization-rider-service-levels>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input id="editOrganizationRider-input-firstName" matInput type="text" placeholder="First Name" formControlName="firstName" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input id="editOrganizationRider-input-lastName" matInput type="text" placeholder="Last Name" formControlName="lastName" />
      </mat-form-field>

      <mat-form-field
        class="email"
        appearance="outline"
        [actionTooltip]="emailTooltipDescription"
        [actionTooltipButtonText]="'Decline'"
        [actionTooltipShow]="shouldShowDeclineTooltip && !editOrganizationRiderForm.get('emailAddress')?.dirty"
        [actionTooltipButtonCallback]="tooltipDismissCallback"
        [subscriptSizing]="shouldShowEmailDeclineSubtext ? 'dynamic' : 'fixed'"
      >
        <mat-label>Email Address</mat-label>

        <input id="editOrganizationRider-input-emailAddress" matInput type="text" placeholder="Email Address" formControlName="emailAddress" />
        <mat-hint id="editOrganizationRider-email-text-declinedOn" class="spacer" *ngIf="shouldShowEmailDeclineSubtext">
          Declined on {{ data.organizationRiderDetail.riderEmailDeclinedAt | date : 'short' }}
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" [subscriptSizing]="invalidPhoneNumber ? 'dynamic' : 'fixed'">
        <mat-label>Phone Number</mat-label>
        <input id="editOrganizationRider-input-phoneNumber" matInput type="text" placeholder="Phone Number" formControlName="phoneNumber" uzPhoneNumberInput />
        <mat-hint class="text-danger" *ngIf="invalidPhoneNumber">
          This phone number needs updating. Please edit and save to store the correct value in our system
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" (click)="picker.open()" class="date-of-birth">
        <mat-label>Date of Birth</mat-label>
        <input
          id="editOrganizationRider-date-dateOfBirth"
          matInput
          [matDatepicker]="picker"
          name="dateOfBirth"
          formControlName="dateOfBirth"
        />
        <mat-icon matSuffix class="material-icons-two-tone">calendar_today</mat-icon>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <mat-dialog-actions align="end">
      <button id="editOrganizationRider-button-cancel" mat-raised-button mat-dialog-close>Cancel</button>
      <button id="editOrganizationRider-button-save" mat-raised-button color="primary" type="submit" [disabled]="editOrganizationRiderForm.invalid">Save</button>
    </mat-dialog-actions>
  </form>
</div>
